import syncProgram from 'actions/program/syncProgram';

function programChanged({ dispatch }, { program, notifyingDirector }) {
  dispatch(syncProgram({ program, notifyingDirector }));
}

export default programChanged;
